<template>
    <div>
        <div class="is-main f-mb15">
            <div class="container" style="padding: 0;">
                <div style="padding: 0 15px;">
                    <section class="m-location f-mb10">
                        <span>当前位置：</span>
                        <a href="/">网站首页</a> &gt;
                        <a>文章详情</a>
                    </section>
                </div>

                <div class="m-pgpdbox1" style="padding: 20px 15px 0;background: white;">
                    <div v-if="articleAvailable"  class="m-detailbox">
                        <h1 class="u-lgtit text-center f-mb15 f-md-mb10">{{ articleDetail.title }}</h1>
                        <div class="m-dtfuns f-clearfix" :class="{ noBorder: articleDetail.cateId === 83 }">
                            <div class="u-wzinfo f-fl f-md-fn">
                                <span>发布时间：{{ articleDetail.time }}</span>
                                <span>作者：{{ articleDetail.author }}</span>
                                <span>浏览：{{ articleDetail.views }} 次</span>
                            </div>
                        </div>

                        <div class="m-dtfuns f-clearfix" style="border: 0;" v-if="articleDetail.cateId === 83">
                            <el-tabs stretch v-model="progressStatus"  @tab-click="handleProgressStatusChange">
                                <el-tab-pane  label="招标" name="1" :disabled="!articleDetail.tenderId"/>
                                <el-tab-pane label="中标" name="2" :disabled="!articleDetail.bidId"/>

                            </el-tabs>
                        </div>
                        <div class="m-dtfonts">
                            <div class="m-dttexts f-clearfix j-fontContent" id="zoom" v-html="articleDetail.detail">
                            </div>
                        </div>
                        <div class="m-dtdownload f-mb15">
                            <ul>
                            </ul>
                        </div>
                        <div class="m-btfuns f-clearfix f-mb15">
                            <ul class="f-fr">
                                <li class="u-gotp j-goTop">
                                    <a :href="getFileUrl(item)" target="_blank"
                                       v-for="(item, index) in articleDetail.files"
                                       :key="index">
                                        {{ '附件：' + getFilesName(item) }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="m-dtsxqh f-clearfix" v-if="articleDetail.cateId !== 83">
                            <ul>
                                <li class="f-fl u-dtprev" @click="handlePrev">
                                    上一条：
                                    <a v-if="prev != null">{{ prev.title }}</a>
                                    <a v-else>没有上一条了</a>
                                </li>
                                <li class="f-fr u-dtnext" @click="handleNext">
                                    下一条：
                                    <a v-if="next != null">{{ next.title }}</a>
                                    <a v-else>没有下一条了</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else class="article-offline">
                        <h2>文章未上架</h2>
                        <p>该文章暂未发布或已下架</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/api'

export default {
    name: "detail",
    data() {
        return {
            articleDetail: {},
            next: {},
            prev: {},
            progressStatusList: [{
                id: '1',
                name: "招标"
            }, {
                id: '2',
                name: "中标"
            }],
            progressStatus: undefined,
            articleAvailable: true
        }
    },
    created() {
        this.activeId = this.$route.query.id
        this.getArticleDetail(this.$route.query.id)
    },
    methods: {

        handleProgressStatusChange() {
            if (this.progressStatus === '1') {
                this.getArticleDetail(this.articleDetail.tenderId)
            } else {
                this.getArticleDetail(this.articleDetail.bidId)
            }

        },
        removeTextIndent() {
            const container = this.$refs.htmlContainer;
            if (container) {
                const allElements = container.querySelectorAll('*');
                console.log('allElements', allElements)
                allElements.forEach(el => {
                    el.style.textIndent = ''; // 移除 text-indent 样式
                });
            }
        },
        getArticleDetail(id) {
            api.articleItem({articleId: id}).then(res => {

                if (res.status !== 1) {
                    this.articleAvailable = false
                    this.articleDetail = {}   // 可选，避免残留上一次内容
                    return
                }

                this.articleAvailable = true

                let head = document.getElementsByTagName("head")    // 修改meta
                let meta = document.createElement("meta")
                meta.content = res.description

                if (this.$store.state.meta != null) {
                    head[0].replaceChild(meta, this.$store.state.meta)
                } else {
                    head[0].appendChild(meta)
                }
                this.$store.state.meta = meta


                console.log(res)

                this.articleDetail = res
                if (this.articleDetail.files != null) {
                    this.articleDetail.files = JSON.parse(this.articleDetail.files)
                }
                this.$nextTick(() => {
                    this.removeTextIndent();
                });
                this.next = res.next
                this.prev = res.prev
                if (res.tenderId === res.id) {
                    this.progressStatus = "1"
                } else if (res.bidId === res.id) {
                    this.progressStatus = "2"
                }
            })
        },
        handleNext() {
            if (this.next) {
                this.$store.commit('SET_ACTIVEARTIVLEID', this.next.id)
                this.$router.push({
                    path: `/detail?id=${this.next.id}`
                })
            }

        },
        handlePrev() {
            if (this.prev) {
                this.$store.commit('SET_ACTIVEARTIVLEID', this.prev.id)
                this.$router.push({
                    path: `/detail?id=${this.prev.id}`
                })
            }

        }
    },
    computed: {
        getFilesName() {
            return item => {
                return item.slice(53)
            }
        },
        getFileUrl() {
            return item => {
                return item.slice(0, 53) + encodeURIComponent(item.slice(53))
            }
        }
    },
    watch: {
        '$store.state.activeArticleId': function (newValue) {
            this.getArticleDetail(newValue)
        }
    }
}
</script>

<style scoped>

.normal-border {
    border: 1px solid #ccc;
}

.noBorder {
    border: 0 !important;
}
.article-offline {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #999;
    background: #fff;
    min-height: calc(100vh - 200px);
}
</style>
